let language = {
    "manual_order": "手动",
    "automatic_order": "定期",
    "direct_order": "直接",
};

export { language }
